if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
             document.querySelectorAll('.product-form__input--pill input').forEach(function(clickitem) {
                clickitem.checked = false;
                clickitem.removeAttribute('checked');
              });

                   var customerName = '';
                   var customerId = document.body.getAttribute('data-getcustomeremail');
                   var customerName = document.body.getAttribute('data-getcustomername');
                   const collAndproductList = () => {
                        const formData = new FormData();
                        formData.append('customerId', customerId);
                        formData.append('list_order', 'reorder');
                        formData.append('get_List', 'true');
                        fetch('https://managefirstaid.com/Mfasco/reorder/alllist_name.php', {
                            method: 'POST',
                            body: formData, 
                        }).then(response => {
                          if (!response.ok) {}
                          return response.text();
                        }).then(response => {
                           let reorder_list = document.querySelector("#orderListDropCont_list");
                           reorder_list.innerHTML = '';
                           var respData = JSON.parse(response);	
                           if(respData['status'] == 1){
                              var regionData = respData['data'];
                              regionData.forEach(function(items,index) {
                                   let rowcount = items.rowcount_list;
                                   let listId = items.id;
                                   let listfullName = items.name;
                                   var arr = listfullName.split('=');
                                   var reorder_name = '<div id="reorderList-item-'+index+'" class="reorderListItem" data-listid="'+listId+'" data-customerId="'+customerId+'" data-listname="'+listfullName+'" data-first="'+arr[0]+'" data-second="'+arr[1]+'">'+  
                                    '<a href="javascript:void(0);" class="reorderListItem--title full-unstyled-link" data-listid="'+listId+'" data-customerId="'+customerId+'" data-listname="'+listfullName+'" data-first="'+arr[0]+'" data-second="'+arr[1]+'">'+arr[0]+'</a>'+
                                    '<p class="reorderListItem--total"><span class="reorderList-totalcount">'+rowcount+'</span> Items</p>'+
                                  '</div>';
                                  reorder_list.insertAdjacentHTML('beforeend', reorder_name);
                              });
                           }
                        }).catch(error => {});
                        
                   }
                   document.addEventListener("click", function(event) {
                       if(document.body.classList.contains('overflow-hidden')) {
                        if(event.target.classList.contains("newListLink-createbutton")) {
                           var newlistCreate = event.target.closest('.reorderList__addlist');
                           if(newlistCreate){
                              var newListInput = newlistCreate.querySelector('.newList');
                              if(newListInput){
                                var inputValue = newListInput.value;
                                if(inputValue){
                                   const formData = new FormData();
                                   formData.append('customerId', customerId);
                                   formData.append('customerName', customerName);
                                   formData.append('listName', inputValue);
                                   formData.append('addList', 'true');
                                   fetch('https://managefirstaid.com/Mfasco/reorder/reorder_list.php', {
                                        method: 'POST',
                                        body: formData, 
                                    }).then(response => {
                                        if (!response.ok) {}
                                        return response.text();
                                    }).then(response => {
                                        document.querySelector('.createNewList--grid').style.display = 'none';
                                        document.querySelector('.newListLink-reorder').style.display = 'block';
                                        collAndproductList();
                                    }).catch(error => {});
                                }else{
                                  alert('Please input a name for your new reorder list.');
                                  return false;
                                }
                              }
                           }
                        }
              
                        if ((event.target.classList.contains("reorderListItem--title")) || (event.target.classList.contains("reorderListItem"))) {
                           var listaddProduct = event.target.closest('.orderList--content');
                           if(listaddProduct){
                               const formData = new FormData();
                             
                               var thsHandle = listaddProduct.getAttribute('prohandle');
                               var thsSku = listaddProduct.getAttribute('prosku');
                               var listNameId = event.target.getAttribute('data-listid');
                               formData.append('customerId', customerId);
                               formData.append('listId', listNameId);
                               formData.append('handle', thsHandle);
                               formData.append('sku', thsSku);
                               formData.append('addList_product', 'true');
              
                               fetch('https://managefirstaid.com/Mfasco/reorder/reorder_list.php', {
                                    method: 'POST',
                                    body: formData, 
                                }).then(response => {
                                    if (!response.ok) {}
                                    return response.text();
                                }).then(response => {
                                    document.querySelector('#addtoListOrder_popup').style.display = 'none';
                                    collAndproductList();
                                    alert(response);
                                    return false;
                                }).catch(error => {
                                });
                           }
                        }
                       }
                     });
                      const addTolistButton = document.querySelectorAll('.addTolistButtonPopup');
                      const addTolistPoup = document.querySelector('#addtoListOrder_popup');
                      if (addTolistButton || addTolistPoup) {
                         const newOrderList = addTolistPoup.querySelector('.newListLink-reorder');
                         const newOrderListGrid = addTolistPoup.querySelector('.createNewList--grid');
                         const orderListClose = addTolistPoup.querySelector('.orderListProductClose');
                         const orderList = addTolistPoup.querySelector('.orderList--content');
                         
                        addTolistButton.forEach(button => {
                          button.addEventListener('click', (event) => { 
                           addTolistPoup.style.display = 'block'; 
                              var get_handle = button.getAttribute('data-phandle');
                              var get_sku = button.getAttribute('data-psku');
                            
                             if(customerId){
                                const orderListContent = document.querySelector(".orderList--content");
                               orderListContent.setAttribute("proHandle", get_handle);
                               orderListContent.setAttribute("proSku", get_sku);
                               collAndproductList();
                             }
                          });
                         });
                           orderListClose.addEventListener('click', (event) => {  
                           addTolistPoup.style.display = 'none'; 
                           newOrderList.style.display = 'block'; 
                           newOrderListGrid.style.display = 'none';
                         }); 
                        if (newOrderList) {
                           newOrderList.addEventListener('click', (event) => {  
                            newOrderList.style.display = 'none'; 
                            newOrderListGrid.style.display = 'block'; 
                         });
                        }
                      }
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
                
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

    }
  );
}
